import { Link } from "react-router-dom";
import { Star, ArrowUpRight } from "lucide-react";

export const StarRating = ({ value = 5, size = 14 }) => (
  <span className="inline-flex items-center gap-0.5 text-amber-400" aria-label={`${value} stars`}>
    {[1, 2, 3, 4, 5].map((i) => (
      <Star key={i} style={{ width: size, height: size }}
        className={i <= Math.round(value) ? "fill-amber-400" : "fill-none text-muted-foreground/40"} />
    ))}
  </span>
);

export const ArticleCard = ({ a }) => (
  <Link to={a.legacy_path || `/blog/${a.slug}`} data-testid={`article-card-${a.slug}`}
    className="group rounded-2xl glass-lite overflow-hidden hover:-translate-y-1 transition-transform duration-300 flex flex-col">
    <div className="aspect-[16/10] overflow-hidden">
      <img src={a.cover} alt={a.title} loading="lazy"
        className="h-full w-full object-cover group-hover:scale-105 transition-transform duration-500" />
    </div>
    <div className="p-5 flex flex-col flex-1">
      <span className="text-xs font-semibold text-primary uppercase tracking-wide">{a.word_count} words</span>
      <h3 className="font-head font-bold text-lg mt-1 leading-snug line-clamp-2">{a.title}</h3>
      <p className="text-sm text-muted-foreground mt-2 line-clamp-2 flex-1">{a.excerpt}</p>
      <span className="mt-3 inline-flex items-center gap-1 text-sm font-semibold text-primary">
        Read article <ArrowUpRight className="h-4 w-4 group-hover:translate-x-0.5 transition-transform" />
      </span>
    </div>
  </Link>
);

export const ProductCard = ({ p }) => (
  <Link to={`/shop/${p.slug}`} data-testid={`product-card-${p.slug}`}
    className="group rounded-2xl glass-lite overflow-hidden hover:-translate-y-1 hover:shadow-xl hover:shadow-primary/20 transition-transform duration-300 flex flex-col">
    <div className="aspect-square overflow-hidden bg-secondary/40">
      <img src={p.image} alt={p.name} loading="lazy"
        className="h-full w-full object-cover group-hover:scale-105 transition-transform duration-500" />
    </div>
    <div className="p-4 flex flex-col flex-1">
      <h3 className="font-head font-bold leading-snug line-clamp-2">{p.name}</h3>
      <div className="flex items-center gap-2 mt-1 text-sm">
        <StarRating value={p.rating} />
        <span className="text-muted-foreground">{p.rating} ({p.review_count?.toLocaleString?.() || p.review_count})</span>
      </div>
      <div className="mt-auto pt-3 flex items-center justify-between">
        <span className="font-head font-extrabold text-xl text-primary">${p.price?.toLocaleString?.(undefined, {minimumFractionDigits: 2}) ?? p.price}</span>
        <span className="text-xs font-semibold rounded-full bg-primary/10 text-primary px-3 py-1">View</span>
      </div>
    </div>
  </Link>
);
